import React, { useState } from 'react';
import '../styles/SmartClaimsAssistant.css';
import { uploadSmartClaimDocument } from '../services/api';

function SmartClaimsAssistant() {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');
  const [userId, setUserId] = useState('2');
  const [claimType, setClaimType] = useState('fracture');
  const todayDate = new Date().toISOString();
  const [amount, setAmount] = useState(5000);
  const [description, setDescription] = useState('metro');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;
    setStatus('Uploading...');
    try {
      const response = await uploadSmartClaimDocument(
        file,
        userId,
        claimType,
        description,
        amount
      );
      setStatus(response.message || 'Upload complete!');
    } catch (error) {
      setStatus('Upload failed.');
    }
  };

  return (
    <div className="smart-claims-container">
      <h2 className="smart-claims-title">Smart Claims Assistant</h2>
      <form className="smart-claims-form" onSubmit={e => { e.preventDefault(); handleUpload(); }}>
        <div className="smart-claims-row">
          <label>User ID</label>
          <input type="text" value={userId} onChange={e => setUserId(e.target.value)} placeholder="User ID" />
        </div>
        <div className="smart-claims-row">
          <label>Claim Type</label>
          <input type="text" value={claimType} onChange={e => setClaimType(e.target.value)} placeholder="Claim Type" />
        </div>
        <div className="smart-claims-row">
          <label>Claim Date</label>
          <input type="text" value={todayDate} readOnly style={{ background: "#eee", cursor: "not-allowed" }} />
        </div>
        <div className="smart-claims-row">
          <label>Amount</label>
          <input type="number" value={amount} onChange={e => setAmount(e.target.value)} placeholder="Amount" />
        </div>
        <div className="smart-claims-row">
          <label>Description</label>
          <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Description" />
        </div>
        <div className="smart-claims-row">
          <label>Upload Document</label>
          <input type="file" accept=".pdf,.jpg,.png" onChange={handleFileChange} />
        </div>
        <button className="smart-claims-btn" type="submit">Upload Document</button>
        <p className="smart-claims-status">{status}</p>
      </form>
    </div>
  );
}

export default SmartClaimsAssistant;